import { useEffect } from 'react';

import classes from './use-disable-overscroll.module.scss';

export const useDisableOverscroll = () => {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.add(classes.disableOverscroll);
    document.body.classList.add(classes.disableOverscroll);

    return () => {
      document.documentElement.classList.remove(classes.disableOverscroll);
      document.body.classList.remove(classes.disableOverscroll);
    };
  }, []);
};
